import { DiamondNode, DiamondNodeModel, h } from '@logicflow/core';
import { getThemeStyle } from '../theme';
import { initLabelOffset } from './textUtils';

class EventBasedGatewayView extends DiamondNode {
  getShape() {
    const { model } = this.props;
    const { x, y, rx, ry } = model;
    void model.properties.__tv; // MobX: re-render on theme change
    const style = model.getNodeStyle();
    const points = `${x},${y - ry} ${x + rx},${y} ${x},${y + ry} ${x - rx},${y}`;

    return h('g', {}, [
      h('polygon', {
        points,
        ...style,
      }),
      // Double circle (BPMN standard for Event-based Gateway)
      h('circle', {
        cx: x,
        cy: y,
        r: 11,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.5,
      }),
      h('circle', {
        cx: x,
        cy: y,
        r: 8,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.5,
      }),
      // Pentagon inside
      h('path', {
        d: `M ${x} ${y - 5}
            L ${x + 4.8} ${y - 1.5}
            L ${x + 3} ${y + 4}
            L ${x - 3} ${y + 4}
            L ${x - 4.8} ${y - 1.5} Z`,
        fill: 'none',
        stroke: style.stroke,
        strokeWidth: 1.2,
      }),
    ]);
  }
}

class EventBasedGatewayModel extends DiamondNodeModel {
  initNodeData(data) {
    super.initNodeData(data);
    this.rx = 30;
    this.ry = 30;
    initLabelOffset(this, data, this.ry + 18);
  }

  getNodeStyle() {
    const style = super.getNodeStyle();
    const t = getThemeStyle(this.graphModel, 'eventBasedGateway');
    style.stroke = t.stroke || '#389e0d';
    style.strokeWidth = t.strokeWidth ?? 2;
    style.fill = t.fill || '#f6ffed';
    return style;
  }
}

export const EventBasedGateway = {
  type: 'epx:EventBasedGateway',
  view: EventBasedGatewayView,
  model: EventBasedGatewayModel,
};
